import React from 'react';
import { BuilderFieldLabel, BuilderFieldLabelProps } from '../../wrappers/label/builderFieldLabel.component';
import { BuilderFieldError, BuilderFieldErrorProps, ErrorSign } from '../../wrappers/error/builderFieldError.component';
import { AppTagInputProps } from 'uikit/inputs/tagInput/appTagInput';
import { AppTagInput } from 'uikit/inputs';

export type AppTagInputFieldProps = {
  labelProps: BuilderFieldLabelProps;
  errorProps?: BuilderFieldErrorProps;
} & AppTagInputProps;

export const AppTagInputField = React.forwardRef<HTMLInputElement, AppTagInputFieldProps>(
  ({ errorProps, labelProps, disabled, ...rest }, ref) => {
    return (
      <BuilderFieldError {...errorProps}>
        <BuilderFieldLabel
          disabled={disabled}
          rightSection={errorProps?.errors ? <ErrorSign /> : <></>}
          {...labelProps}
        >
          <AppTagInput ref={ref} disabled={disabled} invalid={!!errorProps?.errors} {...rest} />
        </BuilderFieldLabel>
      </BuilderFieldError>
    );
  },
);
